@for (state of infoStates; track $index) {
  @if (loading && state) { <span class="height-m width-full loading-animate"></span> }
  @else if (state) {
  <span class="width-full tooltip-hover">
    <span class="am-flex-align am-flex-wrap gap-xxs">
      <span class="am-flex-center text-xl" [ngClass]="state.icon + ' ' + state.color"></span>
      <span>{{ state.info }}</span>
      @if (state.by     ) { <span>von {{ state.by }}</span> }
      @if (state.at     ) { <span>am {{ state.at | date:'dd.MM.yyyy HH:mm' }}</span> }
      @if (state.extra  ) { <span [ngClass]="state.extraClass">{{ state.extra }}</span> }
      @if (state.tooltip) {
        <span class="am-flex-center text-xl icon-circle-question"></span>
        <div class="web-tooltip top font-s white width-300">{{ state.tooltip }}</div>
      }
    </span>
  </span>
}
}
